import React from 'react'

import { cn } from '@/utilities/ui'

import type { SeloDestaqueVM } from './types'

/**
 * Selo «Exclusivo» / «Ao vivo» da faixa Hero (R7) — o carimbo estilo Business Insider / CNN.
 *
 * 🔴 SEM `getTranslations` e sem qualquer import de servidor, DE PROPÓSITO: este componente é
 * renderizado também dentro do carrossel mobile, que é `'use client'`. O rótulo chega pronto no VM
 * (traduzido no servidor). Foi exatamente o inverso disto que derrubou a home em 18/08/2026.
 *
 * Não tem variante clara/escura de propósito: o fundo é SÓLIDO nos dois casos, o que já garante
 * contraste tanto na coluna branca (desktop) quanto sobre a foto do carrossel (mobile).
 */
export function SeloDestaque({ badge, className }: { badge: SeloDestaqueVM; className?: string }) {
  const aoVivo = badge.kind === 'live'
  return (
    <span
      data-featured={badge.kind}
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 px-2 py-0.5 text-[10px] font-bold tracking-wide uppercase',
        aoVivo ? 'bg-red-600 text-white' : 'bg-primary text-primary-foreground',
        className,
      )}
    >
      {aoVivo ? <PontoPulsante /> : null}
      {badge.label}
    </span>
  )
}

/**
 * Ponto pulsante do «Ao vivo» — duas camadas (halo que expande + núcleo sólido), o mesmo desenho do
 * `MenuPulseDot`. `motion-reduce:animate-none` atende a WCAG 2.3.3 sem apagar o ponto.
 */
function PontoPulsante() {
  return (
    <span className="relative flex size-1.5 shrink-0" aria-hidden>
      <span className="absolute inline-flex size-full animate-ping rounded-full bg-white opacity-75 motion-reduce:animate-none" />
      <span className="relative inline-flex size-1.5 rounded-full bg-white" />
    </span>
  )
}
